import { render, staticRenderFns } from "./ForwardRequest.vue?vue&type=template&id=6e775cbb&"
import script from "./ForwardRequest.vue?vue&type=script&lang=js&"
export * from "./ForwardRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports